var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcAttendance = function SvgIcAttendance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4 10.8c-.8 0-1.6.1-2.3.4-1-.9-2.3-1.6-3.6-1.9 1.5-.8 2.6-2.4 2.6-4.3 0-2.7-2.2-4.9-4.9-4.9-2.8-.1-5 2.1-5 4.8 0 1.9 1 3.5 2.6 4.3-3.4.9-6 3.6-6.7 7.2-.1.6 0 1.2.4 1.7s1 .8 1.7.8H11c.7 2.9 3.3 5 6.4 5 3.7 0 6.6-3 6.6-6.6s-3-6.5-6.6-6.5zM6.1 4.9c0-1.7 1.4-3 3-3 1.7 0 3.1 1.4 3.1 3 0 1.7-1.4 3.1-3.1 3.1-1.6 0-3-1.4-3-3.1zm4.7 12.2H2.2c-.1 0-.2-.1-.2-.1 0-.1-.1-.1-.1-.2.7-3.5 3.7-6 7.2-6 1.6 0 3 .5 4.2 1.3-1.4 1.2-2.4 3-2.5 5zm9.6-.8-3.3 3.3c-.2.2-.4.2-.6.2s-.4-.1-.6-.2L14.3 18c-.3-.3-.3-.8 0-1.2.3-.3.8-.3 1.2 0l1.1 1.1 2.7-2.7c.3-.3.8-.3 1.2 0 .3.3.3.8-.1 1.1z"
  })));
};
export default SvgIcAttendance;